// AUTO-GENERATED by scripts/generateFonts.ts from fonts.json.
// Do NOT edit by hand. Run `bun run fonts` to regenerate.

export type FontCategoryKey = "khmer" | "masterpiece" | "phoenix-digital-art" | "one-type" | "aka" | "saimoon" | "unknown" | "other" | "sil";

/** One weight/style of a family (Google-Fonts style: 400 Regular, 700 Bold, ...). */
export interface FontVariant {
  weight: number;
  italic: boolean;
  label: string;
  filePath: string;
  downloadFileName: string;
  localName: string;
}

export interface FontDefinition {
  id: string;
  displayName: string;
  category: FontCategoryKey;
  /** Default variant's file — kept for callers that don't care about weights. */
  filePath: string;
  cssFamily: string;
  previewFamily: string;
  localName: string;
  downloadFileName: string;
  languages: string[];
  /** Always at least one entry, sorted upright-first then by weight. */
  variants: FontVariant[];
  defaultWeight: number;
  defaultItalic: boolean;
}

export interface FontCategory {
  key: FontCategoryKey;
  title: string;
  description: string;
  link: string;
  fonts: FontDefinition[];
}

export interface StyleCategory {
  name: string;
  fonts: string[];
}

export interface LanguageCategory {
  id: string;
  name: string;
}

export const fontCatalog: FontCategory[] = [
  {
    key: "khmer",
    title: "Khmer Type",
    description: "Modern and legacy Unicode fonts from KhmerType collection.",
    link: "https://github.com/khmertype",
    fonts: [
      {
        id: "khmer:MyanmarAngoun",
        displayName: "MyanmarAngoun",
        category: "khmer",
        filePath: "/KhmerType/MyanmarAngoun.ttf",
        cssFamily: "MyanmarAngoun",
        previewFamily: "MMFont-MyanmarAngoun",
        localName: "Myanmar Angoun",
        downloadFileName: "MyanmarAngoun.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarAngoun.ttf", downloadFileName: "MyanmarAngoun.ttf", localName: "Myanmar Angoun" },
        ],
      },
      {
        id: "khmer:MyanmarChatu",
        displayName: "MyanmarChatu",
        category: "khmer",
        filePath: "/KhmerType/MyanmarChatu.ttf",
        cssFamily: "MyanmarChatu",
        previewFamily: "MMFont-MyanmarChatu",
        localName: "Myanmar Chatu",
        downloadFileName: "MyanmarChatu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 300, italic: false, label: "Light", filePath: "/KhmerType/MyanmarChatuLight.ttf", downloadFileName: "MyanmarChatuLight.ttf", localName: "Myanmar Chatu Light" },
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarChatu.ttf", downloadFileName: "MyanmarChatu.ttf", localName: "Myanmar Chatu" },
        ],
      },
      {
        id: "khmer:MyanmarGantgaw",
        displayName: "MyanmarGantgaw",
        category: "khmer",
        filePath: "/KhmerType/MyanmarGantgaw.ttf",
        cssFamily: "MyanmarGantgaw",
        previewFamily: "MMFont-MyanmarGantgaw",
        localName: "Myanmar Gantgaw",
        downloadFileName: "MyanmarGantgaw.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarGantgaw.ttf", downloadFileName: "MyanmarGantgaw.ttf", localName: "Myanmar Gantgaw" },
        ],
      },
      {
        id: "khmer:MyanmarKhyay",
        displayName: "MyanmarKhyay",
        category: "khmer",
        filePath: "/KhmerType/MyanmarKhyay.ttf",
        cssFamily: "MyanmarKhyay",
        previewFamily: "MMFont-MyanmarKhyay",
        localName: "Myanmar Khyay",
        downloadFileName: "MyanmarKhyay.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarKhyay.ttf", downloadFileName: "MyanmarKhyay.ttf", localName: "Myanmar Khyay" },
        ],
      },
      {
        id: "khmer:MyanmarKuttar",
        displayName: "MyanmarKuttar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarKuttar.ttf",
        cssFamily: "MyanmarKuttar",
        previewFamily: "MMFont-MyanmarKuttar",
        localName: "Myanmar Kuttar",
        downloadFileName: "MyanmarKuttar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarKuttar.ttf", downloadFileName: "MyanmarKuttar.ttf", localName: "Myanmar Kuttar" },
        ],
      },
      {
        id: "khmer:MyanmarNayone",
        displayName: "MyanmarNayone",
        category: "khmer",
        filePath: "/KhmerType/MyanmarNayone.ttf",
        cssFamily: "MyanmarNayone",
        previewFamily: "MMFont-MyanmarNayone",
        localName: "Myanmar Nayone",
        downloadFileName: "MyanmarNayone.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarNayone.ttf", downloadFileName: "MyanmarNayone.ttf", localName: "Myanmar Nayone" },
        ],
      },
      {
        id: "khmer:MyanmarNjaun",
        displayName: "MyanmarNjaun",
        category: "khmer",
        filePath: "/KhmerType/MyanmarNjaun.ttf",
        cssFamily: "MyanmarNjaun",
        previewFamily: "MMFont-MyanmarNjaun",
        localName: "Myanmar Njaun",
        downloadFileName: "MyanmarNjaun.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarNjaun.ttf", downloadFileName: "MyanmarNjaun.ttf", localName: "Myanmar Njaun" },
        ],
      },
      {
        id: "khmer:MyanmarPauklay",
        displayName: "MyanmarPauklay",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPauklay.ttf",
        cssFamily: "MyanmarPauklay",
        previewFamily: "MMFont-MyanmarPauklay",
        localName: "Myanmar Pauklay",
        downloadFileName: "MyanmarPauklay.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarPauklay.ttf", downloadFileName: "MyanmarPauklay.ttf", localName: "Myanmar Pauklay" },
        ],
      },
      {
        id: "khmer:MyanmarPhetsot",
        displayName: "MyanmarPhetsot",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhetsot.ttf",
        cssFamily: "MyanmarPhetsot",
        previewFamily: "MMFont-MyanmarPhetsot",
        localName: "Myanmar Phetsot",
        downloadFileName: "MyanmarPhetsot.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarPhetsot.ttf", downloadFileName: "MyanmarPhetsot.ttf", localName: "Myanmar Phetsot" },
        ],
      },
      {
        id: "khmer:MyanmarPhiksel",
        displayName: "MyanmarPhiksel",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhiksel.ttf",
        cssFamily: "MyanmarPhiksel",
        previewFamily: "MMFont-MyanmarPhiksel",
        localName: "Myanmar Phiksel",
        downloadFileName: "MyanmarPhiksel.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarPhiksel.ttf", downloadFileName: "MyanmarPhiksel.ttf", localName: "Myanmar Phiksel" },
        ],
      },
      {
        id: "khmer:MyanmarPhikselSmooth",
        displayName: "MyanmarPhikselSmooth",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhikselSmooth.ttf",
        cssFamily: "MyanmarPhikselSmooth",
        previewFamily: "MMFont-MyanmarPhikselSmooth",
        localName: "Myanmar Phiksel Smooth",
        downloadFileName: "MyanmarPhikselSmooth.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarPhikselSmooth.ttf", downloadFileName: "MyanmarPhikselSmooth.ttf", localName: "Myanmar Phiksel Smooth" },
        ],
      },
      {
        id: "khmer:MyanmarPonenyet",
        displayName: "MyanmarPonenyet",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPonenyet.ttf",
        cssFamily: "MyanmarPonenyet",
        previewFamily: "MMFont-MyanmarPonenyet",
        localName: "Myanmar Ponenyet",
        downloadFileName: "MyanmarPonenyet.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarPonenyet.ttf", downloadFileName: "MyanmarPonenyet.ttf", localName: "Myanmar Ponenyet" },
        ],
      },
      {
        id: "khmer:MyanmarSabae",
        displayName: "MyanmarSabae",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSabae.ttf",
        cssFamily: "MyanmarSabae",
        previewFamily: "MMFont-MyanmarSabae",
        localName: "Myanmar Sabae",
        downloadFileName: "MyanmarSabae.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarSabae.ttf", downloadFileName: "MyanmarSabae.ttf", localName: "Myanmar Sabae" },
        ],
      },
      {
        id: "khmer:MyanmarSagar",
        displayName: "MyanmarSagar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSagar.ttf",
        cssFamily: "MyanmarSagar",
        previewFamily: "MMFont-MyanmarSagar",
        localName: "Myanmar Sagar",
        downloadFileName: "MyanmarSagar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarSagar.ttf", downloadFileName: "MyanmarSagar.ttf", localName: "Myanmar Sagar" },
        ],
      },
      {
        id: "khmer:MyanmarSanpya",
        displayName: "MyanmarSanpya",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSanpya.ttf",
        cssFamily: "MyanmarSanpya",
        previewFamily: "MMFont-MyanmarSanpya",
        localName: "Myanmar Sanpya",
        downloadFileName: "MyanmarSanpya.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarSanpya.ttf", downloadFileName: "MyanmarSanpya.ttf", localName: "Myanmar Sanpya" },
        ],
      },
      {
        id: "khmer:MyanmarTagu",
        displayName: "MyanmarTagu",
        category: "khmer",
        filePath: "/KhmerType/MyanmarTagu.ttf",
        cssFamily: "MyanmarTagu",
        previewFamily: "MMFont-MyanmarTagu",
        localName: "Myanmar Tagu",
        downloadFileName: "MyanmarTagu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarTagu.ttf", downloadFileName: "MyanmarTagu.ttf", localName: "Myanmar Tagu" },
        ],
      },
      {
        id: "khmer:MyanmarThuriya",
        displayName: "MyanmarThuriya",
        category: "khmer",
        filePath: "/KhmerType/MyanmarThuriya.ttf",
        cssFamily: "MyanmarThuriya",
        previewFamily: "MMFont-MyanmarThuriya",
        localName: "Myanmar Thuriya",
        downloadFileName: "MyanmarThuriya.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarThuriya.ttf", downloadFileName: "MyanmarThuriya.ttf", localName: "Myanmar Thuriya" },
        ],
      },
      {
        id: "khmer:MyanmarWaso",
        displayName: "MyanmarWaso",
        category: "khmer",
        filePath: "/KhmerType/MyanmarWaso.ttf",
        cssFamily: "MyanmarWaso",
        previewFamily: "MMFont-MyanmarWaso",
        localName: "Myanmar Waso",
        downloadFileName: "MyanmarWaso.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarWaso.ttf", downloadFileName: "MyanmarWaso.ttf", localName: "Myanmar Waso" },
        ],
      },
      {
        id: "khmer:MyanmarYinmar",
        displayName: "MyanmarYinmar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarYinmar.ttf",
        cssFamily: "MyanmarYinmar",
        previewFamily: "MMFont-MyanmarYinmar",
        localName: "Myanmar Yinmar",
        downloadFileName: "MyanmarYinmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/KhmerType/MyanmarYinmar.ttf", downloadFileName: "MyanmarYinmar.ttf", localName: "Myanmar Yinmar" },
        ],
      },
    ],
  },
  {
    key: "masterpiece",
    title: "Masterpiece",
    description: "Masterpiece Unicode fonts for display and body text.",
    link: "https://sourceforge.net/projects/prahita/files/Myanmar%20Unicode%20Fonts/",
    fonts: [
      {
        id: "masterpiece:MasterpieceCTL",
        displayName: "MasterpieceCTL",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceCTL.ttf",
        cssFamily: "MasterpieceCTL",
        previewFamily: "MMFont-MasterpieceCTL",
        localName: "Masterpiece CTL",
        downloadFileName: "MasterpieceCTL.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceCTL.ttf", downloadFileName: "MasterpieceCTL.ttf", localName: "Masterpiece CTL" },
        ],
      },
      {
        id: "masterpiece:MasterpieceLakwel",
        displayName: "MasterpieceLakwel",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceLakwel.ttf",
        cssFamily: "MasterpieceLakwel",
        previewFamily: "MMFont-MasterpieceLakwel",
        localName: "Masterpiece Lakwel",
        downloadFileName: "MasterpieceLakwel.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceLakwel.ttf", downloadFileName: "MasterpieceLakwel.ttf", localName: "Masterpiece Lakwel" },
        ],
      },
      {
        id: "masterpiece:MasterpieceSpringRev",
        displayName: "MasterpieceSpringRev",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceSpringRev.ttf",
        cssFamily: "MasterpieceSpringRev",
        previewFamily: "MMFont-MasterpieceSpringRev",
        localName: "Masterpiece Spring Revolution",
        downloadFileName: "MasterpieceSpringRev.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceSpringRev.ttf", downloadFileName: "MasterpieceSpringRev.ttf", localName: "Masterpiece Spring Revolution" },
        ],
      },
      {
        id: "masterpiece:MasterpieceStadium",
        displayName: "MasterpieceStadium",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceStadium.ttf",
        cssFamily: "MasterpieceStadium",
        previewFamily: "MMFont-MasterpieceStadium",
        localName: "Masterpiece Stadium",
        downloadFileName: "MasterpieceStadium.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceStadium.ttf", downloadFileName: "MasterpieceStadium.ttf", localName: "Masterpiece Stadium" },
        ],
      },
      {
        id: "masterpiece:MasterpieceTawWin",
        displayName: "MasterpieceTawWin",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceTawWin.ttf",
        cssFamily: "MasterpieceTawWin",
        previewFamily: "MMFont-MasterpieceTawWin",
        localName: "Masterpiece Taw Win",
        downloadFileName: "MasterpieceTawWin.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceTawWin.ttf", downloadFileName: "MasterpieceTawWin.ttf", localName: "Masterpiece Taw Win" },
        ],
      },
      {
        id: "masterpiece:MasterpieceUniHand",
        displayName: "MasterpieceUniHand",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniHand.ttf",
        cssFamily: "MasterpieceUniHand",
        previewFamily: "MMFont-MasterpieceUniHand",
        localName: "Masterpiece Uni HandScript",
        downloadFileName: "MasterpieceUniHand.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceUniHand.ttf", downloadFileName: "MasterpieceUniHand.ttf", localName: "Masterpiece Uni HandScript" },
        ],
      },
      {
        id: "masterpiece:MasterpieceUniRound",
        displayName: "MasterpieceUniRound",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniRound.ttf",
        cssFamily: "MasterpieceUniRound",
        previewFamily: "MMFont-MasterpieceUniRound",
        localName: "Masterpiece Uni Round",
        downloadFileName: "MasterpieceUniRound.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceUniRound.ttf", downloadFileName: "MasterpieceUniRound.ttf", localName: "Masterpiece Uni Round" },
        ],
      },
      {
        id: "masterpiece:MasterpieceUniSerif",
        displayName: "MasterpieceUniSerif",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniSerif.ttf",
        cssFamily: "MasterpieceUniSerif",
        previewFamily: "MMFont-MasterpieceUniSerif",
        localName: "Masterpiece Uni Serif",
        downloadFileName: "MasterpieceUniSerif.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceUniSerif.ttf", downloadFileName: "MasterpieceUniSerif.ttf", localName: "Masterpiece Uni Serif" },
        ],
      },
      {
        id: "masterpiece:MasterpieceUniType",
        displayName: "MasterpieceUniType",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniType.ttf",
        cssFamily: "MasterpieceUniType",
        previewFamily: "MMFont-MasterpieceUniType",
        localName: "Masterpiece Uni Type",
        downloadFileName: "MasterpieceUniType.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceUniType.ttf", downloadFileName: "MasterpieceUniType.ttf", localName: "Masterpiece Uni Type" },
        ],
      },
      {
        id: "masterpiece:MasterpieceYayChanZin",
        displayName: "MasterpieceYayChanZin",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceYayChanZin.ttf",
        cssFamily: "MasterpieceYayChanZin",
        previewFamily: "MMFont-MasterpieceYayChanZin",
        localName: "Masterpiece Yay Chan Zin",
        downloadFileName: "MasterpieceYayChanZin.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceYayChanZin.ttf", downloadFileName: "MasterpieceYayChanZin.ttf", localName: "Masterpiece Yay Chan Zin" },
        ],
      },
      {
        id: "masterpiece:MasterpieceDaung",
        displayName: "MasterpieceDaung",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceDaung.ttf",
        cssFamily: "MasterpieceDaung",
        previewFamily: "MMFont-MasterpieceDaung",
        localName: "Masterpiece Daung",
        downloadFileName: "MasterpieceDaung.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceDaung.ttf", downloadFileName: "MasterpieceDaung.ttf", localName: "Masterpiece Daung" },
        ],
      },
      {
        id: "masterpiece:MasterpieceDaungRound",
        displayName: "MasterpieceDaungRound",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceDaungRound.ttf",
        cssFamily: "MasterpieceDaungRound",
        previewFamily: "MMFont-MasterpieceDaungRound",
        localName: "Masterpiece Daung Round",
        downloadFileName: "MasterpieceDaungRound.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/masterpiece/MasterpieceDaungRound.ttf", downloadFileName: "MasterpieceDaungRound.ttf", localName: "Masterpiece Daung Round" },
        ],
      },
    ],
  },
  {
    key: "phoenix-digital-art",
    title: "Phoenix Digital Art",
    description: "Special purpose font releases from Phoenix Digital Art.",
    link: "https://www.facebook.com/PhoenixDigitalArt",
    fonts: [
      {
        id: "phoenix-digital-art:ThitSarShweSi",
        displayName: "ThitSarShweSi",
        category: "phoenix-digital-art",
        filePath: "/PhoenixDigitalArt/ThitSarShweSi.ttf",
        cssFamily: "ThitSarShweSi",
        previewFamily: "MMFont-ThitSarShweSi",
        localName: "Thit Sar Shwe Si",
        downloadFileName: "ThitSarShweSi.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/PhoenixDigitalArt/ThitSarShweSi.ttf", downloadFileName: "ThitSarShweSi.ttf", localName: "Thit Sar Shwe Si" },
        ],
      },
    ],
  },
  {
    key: "one-type",
    title: "One Type",
    description: "Free font releases from One Type.",
    link: "https://www.facebook.com/onetype.fontstudio",
    fonts: [
      {
        id: "one-type:OneTypeChiangMai",
        displayName: "OneTypeChiangMai",
        category: "one-type",
        filePath: "/OneType/OneTypeChiangMai.ttf",
        cssFamily: "OneTypeChiangMai",
        previewFamily: "MMFont-OneTypeChiangMai",
        localName: "OT Free01_ChiangMai",
        downloadFileName: "OneTypeChiangMai.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/OneType/OneTypeChiangMai.ttf", downloadFileName: "OneTypeChiangMai.ttf", localName: "OT Free01_ChiangMai" },
        ],
      },
      {
        id: "one-type:OneTypeMMDot",
        displayName: "OneTypeMMDot",
        category: "one-type",
        filePath: "/OneType/OneTypeMMDot.ttf",
        cssFamily: "OneTypeMMDot",
        previewFamily: "MMFont-OneTypeMMDot",
        localName: "OT Free02_mmDot",
        downloadFileName: "OneTypeMMDot.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/OneType/OneTypeMMDot.ttf", downloadFileName: "OneTypeMMDot.ttf", localName: "OT Free02_mmDot" },
        ],
      },
    ],
  },
  {
    key: "aka",
    title: "A Ka",
    description: "A Ka Myanmar Unicode font family.",
    link: "https://www.facebook.com/profile.php?id=61570100936629",
    fonts: [
      {
        id: "aka:Aka01",
        displayName: "Aka01",
        category: "aka",
        filePath: "/Aka/Aka01-Regular.ttf",
        cssFamily: "Aka01",
        previewFamily: "MMFont-Aka01",
        localName: "A ka 01",
        downloadFileName: "Aka01-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka01-Regular.ttf", downloadFileName: "Aka01-Regular.ttf", localName: "A ka 01" },
          { weight: 500, italic: false, label: "Medium", filePath: "/Aka/Aka01-Medium.ttf", downloadFileName: "Aka01-Medium.ttf", localName: "A ka 01 Medium" },
          { weight: 700, italic: false, label: "Bold", filePath: "/Aka/Aka01-Bold.ttf", downloadFileName: "Aka01-Bold.ttf", localName: "A ka 01 Bold" },
        ],
      },
      {
        id: "aka:Aka011",
        displayName: "Aka011",
        category: "aka",
        filePath: "/Aka/Aka011-Regular.ttf",
        cssFamily: "Aka011",
        previewFamily: "MMFont-Aka011",
        localName: "A ka -011",
        downloadFileName: "Aka011-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 300, italic: false, label: "Light", filePath: "/Aka/Aka011-Light.ttf", downloadFileName: "Aka011-Light.ttf", localName: "A ka -011 Light" },
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka011-Regular.ttf", downloadFileName: "Aka011-Regular.ttf", localName: "A ka -011" },
          { weight: 700, italic: false, label: "Bold", filePath: "/Aka/Aka011-Bold.ttf", downloadFileName: "Aka011-Bold.ttf", localName: "A ka -011 Bold" },
        ],
      },
      {
        id: "aka:Aka02-Regular",
        displayName: "Aka02-Regular",
        category: "aka",
        filePath: "/Aka/Aka02-Regular.ttf",
        cssFamily: "Aka02-Regular",
        previewFamily: "MMFont-Aka02-Regular",
        localName: "A ka 02",
        downloadFileName: "Aka02-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka02-Regular.ttf", downloadFileName: "Aka02-Regular.ttf", localName: "A ka 02" },
        ],
      },
      {
        id: "aka:Aka03-Regular",
        displayName: "Aka03-Regular",
        category: "aka",
        filePath: "/Aka/Aka03-Regular.ttf",
        cssFamily: "Aka03-Regular",
        previewFamily: "MMFont-Aka03-Regular",
        localName: "A ka 03",
        downloadFileName: "Aka03-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka03-Regular.ttf", downloadFileName: "Aka03-Regular.ttf", localName: "A ka 03" },
        ],
      },
      {
        id: "aka:Aka05-Regular",
        displayName: "Aka05-Regular",
        category: "aka",
        filePath: "/Aka/Aka05-Regular.ttf",
        cssFamily: "Aka05-Regular",
        previewFamily: "MMFont-Aka05-Regular",
        localName: "A ka 05",
        downloadFileName: "Aka05-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka05-Regular.ttf", downloadFileName: "Aka05-Regular.ttf", localName: "A ka 05" },
        ],
      },
      {
        id: "aka:Aka06-Regular",
        displayName: "Aka06-Regular",
        category: "aka",
        filePath: "/Aka/Aka06-Regular.ttf",
        cssFamily: "Aka06-Regular",
        previewFamily: "MMFont-Aka06-Regular",
        localName: "A ka 06",
        downloadFileName: "Aka06-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka06-Regular.ttf", downloadFileName: "Aka06-Regular.ttf", localName: "A ka 06" },
        ],
      },
      {
        id: "aka:Aka08-Regular",
        displayName: "Aka08-Regular",
        category: "aka",
        filePath: "/Aka/Aka08-Regular.ttf",
        cssFamily: "Aka08-Regular",
        previewFamily: "MMFont-Aka08-Regular",
        localName: "A ka 08",
        downloadFileName: "Aka08-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka08-Regular.ttf", downloadFileName: "Aka08-Regular.ttf", localName: "A ka 08" },
        ],
      },
      {
        id: "aka:Aka09-Regular",
        displayName: "Aka09-Regular",
        category: "aka",
        filePath: "/Aka/Aka09-Regular.ttf",
        cssFamily: "Aka09-Regular",
        previewFamily: "MMFont-Aka09-Regular",
        localName: "A ka 09",
        downloadFileName: "Aka09-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka09-Regular.ttf", downloadFileName: "Aka09-Regular.ttf", localName: "A ka 09" },
        ],
      },
      {
        id: "aka:Aka10-Light",
        displayName: "Aka10-Light",
        category: "aka",
        filePath: "/Aka/Aka10-Light.ttf",
        cssFamily: "Aka10-Light",
        previewFamily: "MMFont-Aka10-Light",
        localName: "A ka 10",
        downloadFileName: "Aka10-Light.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/Aka10-Light.ttf", downloadFileName: "Aka10-Light.ttf", localName: "A ka 10" },
        ],
      },
      {
        id: "aka:OpenDyslexic-Regular",
        displayName: "OpenDyslexic-Regular",
        category: "aka",
        filePath: "/Aka/OpenDyslexic-Regular.ttf",
        cssFamily: "OpenDyslexic-Regular",
        previewFamily: "MMFont-OpenDyslexic-Regular",
        localName: "OpenDyslexic",
        downloadFileName: "OpenDyslexic-Regular.ttf",
        languages: ["burmese","mon","rakhine","karen"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/Aka/OpenDyslexic-Regular.ttf", downloadFileName: "OpenDyslexic-Regular.ttf", localName: "OpenDyslexic" },
        ],
      },
    ],
  },
  {
    key: "saimoon",
    title: "Sai Moon",
    description: "Sai Moon Unicode font family.",
    link: "https://www.facebook.com/21.11creative/",
    fonts: [
      {
        id: "saimoon:SM01_WaTokeLay-Regular",
        displayName: "SM01_WaTokeLay-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM01_WaTokeLay-Regular.ttf",
        cssFamily: "SM01_WaTokeLay-Regular",
        previewFamily: "MMFont-SM01_WaTokeLay-Regular",
        localName: "SM01_WaTokeLay",
        downloadFileName: "SM01_WaTokeLay-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM01_WaTokeLay-Regular.ttf", downloadFileName: "SM01_WaTokeLay-Regular.ttf", localName: "SM01_WaTokeLay" },
        ],
      },
      {
        id: "saimoon:SM02_KanBaung-Regular",
        displayName: "SM02_KanBaung-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM02_KanBaung-Regular.ttf",
        cssFamily: "SM02_KanBaung-Regular",
        previewFamily: "MMFont-SM02_KanBaung-Regular",
        localName: "SM02_KanBaung",
        downloadFileName: "SM02_KanBaung-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM02_KanBaung-Regular.ttf", downloadFileName: "SM02_KanBaung-Regular.ttf", localName: "SM02_KanBaung" },
        ],
      },
      {
        id: "saimoon:SM03_KaWai-Regular",
        displayName: "SM03_KaWai-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM03_KaWai-Regular.ttf",
        cssFamily: "SM03_KaWai-Regular",
        previewFamily: "MMFont-SM03_KaWai-Regular",
        localName: "SM03_KaWai",
        downloadFileName: "SM03_KaWai-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM03_KaWai-Regular.ttf", downloadFileName: "SM03_KaWai-Regular.ttf", localName: "SM03_KaWai" },
        ],
      },
      {
        id: "saimoon:SM04_Moon",
        displayName: "SM04_Moon",
        category: "saimoon",
        filePath: "/SaiMoon/SM04_Moon-Regular.ttf",
        cssFamily: "SM04_Moon",
        previewFamily: "MMFont-SM04_Moon",
        localName: "SM04_Moon",
        downloadFileName: "SM04_Moon-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 100, italic: false, label: "Thin", filePath: "/SaiMoon/SM04_Moon-Thin.ttf", downloadFileName: "SM04_Moon-Thin.ttf", localName: "SM04_Moon Thin" },
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM04_Moon-Regular.ttf", downloadFileName: "SM04_Moon-Regular.ttf", localName: "SM04_Moon" },
          { weight: 700, italic: false, label: "Bold", filePath: "/SaiMoon/SM04_Moon-Bold.ttf", downloadFileName: "SM04_Moon-Bold.ttf", localName: "SM04_Moon Bold" },
          { weight: 400, italic: true, label: "Italic", filePath: "/SaiMoon/SM04Moon-Italic.ttf", downloadFileName: "SM04Moon-Italic.ttf", localName: "SM04_Moon Italic" },
        ],
      },
      {
        id: "saimoon:SM06_LaikPyar-Straight",
        displayName: "SM06_LaikPyar-Straight",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Straight.ttf",
        cssFamily: "SM06_LaikPyar-Straight",
        previewFamily: "MMFont-SM06_LaikPyar-Straight",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Straight.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM06_LaikPyar-Straight.ttf", downloadFileName: "SM06_LaikPyar-Straight.ttf", localName: "SM06_LaikPyar" },
        ],
      },
      {
        id: "saimoon:SM06_LaikPyar",
        displayName: "SM06_LaikPyar",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Regular.ttf",
        cssFamily: "SM06_LaikPyar",
        previewFamily: "MMFont-SM06_LaikPyar",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 100, italic: false, label: "Thin", filePath: "/SaiMoon/SM06_LaikPyar-Thin.ttf", downloadFileName: "SM06_LaikPyar-Thin.ttf", localName: "SM06_LaikPyar Thin" },
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM06_LaikPyar-Regular.ttf", downloadFileName: "SM06_LaikPyar-Regular.ttf", localName: "SM06_LaikPyar" },
          { weight: 700, italic: false, label: "Bold", filePath: "/SaiMoon/SM06_LaikPyar-Bold.ttf", downloadFileName: "SM06_LaikPyar-Bold.ttf", localName: "SM06_LaikPyar Bold" },
        ],
      },
      {
        id: "saimoon:SM07_Virus-Regular",
        displayName: "SM07_Virus-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM07_Virus-Regular.ttf",
        cssFamily: "SM07_Virus-Regular",
        previewFamily: "MMFont-SM07_Virus-Regular",
        localName: "SM07_Virus",
        downloadFileName: "SM07_Virus-Regular.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM07_Virus-Regular.ttf", downloadFileName: "SM07_Virus-Regular.ttf", localName: "SM07_Virus" },
        ],
      },
      {
        id: "saimoon:SM08_AntiVirus-Regular",
        displayName: "SM08_AntiVirus-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM08_AntiVirus-Regular.ttf",
        cssFamily: "SM08_AntiVirus-Regular",
        previewFamily: "MMFont-SM08_AntiVirus-Regular",
        localName: "SM08_AntiVirus",
        downloadFileName: "SM08_AntiVirus-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM08_AntiVirus-Regular.ttf", downloadFileName: "SM08_AntiVirus-Regular.ttf", localName: "SM08_AntiVirus" },
        ],
      },
      {
        id: "saimoon:SM09_BeeZee-Regular",
        displayName: "SM09_BeeZee-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM09_BeeZee-Regular.otf",
        cssFamily: "SM09_BeeZee-Regular",
        previewFamily: "MMFont-SM09_BeeZee-Regular",
        localName: "SM09_BeeZee",
        downloadFileName: "SM09_BeeZee-Regular.otf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SaiMoon/SM09_BeeZee-Regular.otf", downloadFileName: "SM09_BeeZee-Regular.otf", localName: "SM09_BeeZee" },
        ],
      },
    ],
  },
  {
    key: "unknown",
    title: "Unknown Author",
    description: "Community fonts with unknown or mixed attribution.",
    link: "",
    fonts: [
      {
        id: "unknown:CherryUnicode",
        displayName: "CherryUnicode",
        category: "unknown",
        filePath: "/unknown/CherryUnicode.ttf",
        cssFamily: "CherryUnicode",
        previewFamily: "MMFont-CherryUnicode",
        localName: "Cherry Unicode",
        downloadFileName: "CherryUnicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/CherryUnicode.ttf", downloadFileName: "CherryUnicode.ttf", localName: "Cherry Unicode" },
        ],
      },
      {
        id: "unknown:Kamjing",
        displayName: "Kamjing",
        category: "unknown",
        filePath: "/unknown/Kamjing.ttf",
        cssFamily: "Kamjing",
        previewFamily: "MMFont-Kamjing",
        localName: "Kamjing-2",
        downloadFileName: "Kamjing.ttf",
        languages: ["burmese","rakhine","karen"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/Kamjing.ttf", downloadFileName: "Kamjing.ttf", localName: "Kamjing-2" },
        ],
      },
      {
        id: "unknown:MyanmarBlack",
        displayName: "MyanmarBlack",
        category: "unknown",
        filePath: "/unknown/MyanmarBlack.ttf",
        cssFamily: "MyanmarBlack",
        previewFamily: "MMFont-MyanmarBlack",
        localName: "Myanmar Black",
        downloadFileName: "MyanmarBlack.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/MyanmarBlack.ttf", downloadFileName: "MyanmarBlack.ttf", localName: "Myanmar Black" },
        ],
      },
      {
        id: "unknown:MyanmarHeadOne",
        displayName: "MyanmarHeadOne",
        category: "unknown",
        filePath: "/unknown/MyanmarHeadOne.ttf",
        cssFamily: "MyanmarHeadOne",
        previewFamily: "MMFont-MyanmarHeadOne",
        localName: "Myanmar Head One",
        downloadFileName: "MyanmarHeadOne.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/MyanmarHeadOne.ttf", downloadFileName: "MyanmarHeadOne.ttf", localName: "Myanmar Head One" },
        ],
      },
      {
        id: "unknown:MyanmarSquare",
        displayName: "MyanmarSquare",
        category: "unknown",
        filePath: "/unknown/MyanmarSquare.ttf",
        cssFamily: "MyanmarSquare",
        previewFamily: "MMFont-MyanmarSquare",
        localName: "Myanmar Square",
        downloadFileName: "MyanmarSquare.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 300, italic: false, label: "Light", filePath: "/unknown/MyanmarSquareLight.ttf", downloadFileName: "MyanmarSquareLight.ttf", localName: "Myanmar Square Light" },
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/MyanmarSquare.ttf", downloadFileName: "MyanmarSquare.ttf", localName: "Myanmar Square" },
        ],
      },
      {
        id: "unknown:NKSSmart2",
        displayName: "NKSSmart2",
        category: "unknown",
        filePath: "/unknown/NKSSmart2.ttf",
        cssFamily: "NKSSmart2",
        previewFamily: "MMFont-NKSSmart2",
        localName: "NK SSmart2",
        downloadFileName: "NKSSmart2.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/NKSSmart2.ttf", downloadFileName: "NKSSmart2.ttf", localName: "NK SSmart2" },
        ],
      },
      {
        id: "unknown:NKSSmart3",
        displayName: "NKSSmart3",
        category: "unknown",
        filePath: "/unknown/NKSSmart3.ttf",
        cssFamily: "NKSSmart3",
        previewFamily: "MMFont-NKSSmart3",
        localName: "NK SSmart3",
        downloadFileName: "NKSSmart3.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/NKSSmart3.ttf", downloadFileName: "NKSSmart3.ttf", localName: "NK SSmart3" },
        ],
      },
      {
        id: "unknown:NKSSmart4",
        displayName: "NKSSmart4",
        category: "unknown",
        filePath: "/unknown/NKSSmart4.ttf",
        cssFamily: "NKSSmart4",
        previewFamily: "MMFont-NKSSmart4",
        localName: "NK SSmart4",
        downloadFileName: "NKSSmart4.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/NKSSmart4.ttf", downloadFileName: "NKSSmart4.ttf", localName: "NK SSmart4" },
        ],
      },
      {
        id: "unknown:NamKhoneUnicode",
        displayName: "NamKhoneUnicode",
        category: "unknown",
        filePath: "/unknown/NamKhoneUnicode.ttf",
        cssFamily: "NamKhoneUnicode",
        previewFamily: "MMFont-NamKhoneUnicode",
        localName: "NamKhoneUnicode",
        downloadFileName: "NamKhoneUnicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/NamKhoneUnicode.ttf", downloadFileName: "NamKhoneUnicode.ttf", localName: "NamKhoneUnicode" },
        ],
      },
      {
        id: "unknown:Yangon",
        displayName: "Yangon",
        category: "unknown",
        filePath: "/unknown/Yangon.ttf",
        cssFamily: "Yangon",
        previewFamily: "MMFont-Yangon",
        localName: "Yangon",
        downloadFileName: "Yangon.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/Yangon.ttf", downloadFileName: "Yangon.ttf", localName: "Yangon" },
        ],
      },
      {
        id: "unknown:YoeYar-One",
        displayName: "YoeYar-One",
        category: "unknown",
        filePath: "/unknown/YoeYar-One.ttf",
        cssFamily: "YoeYar-One",
        previewFamily: "MMFont-YoeYar-One",
        localName: "YoeYar-One",
        downloadFileName: "YoeYar-One.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/unknown/YoeYar-One.ttf", downloadFileName: "YoeYar-One.ttf", localName: "YoeYar-One" },
        ],
      },
    ],
  },
  {
    key: "other",
    title: "Other Fonts",
    description: "Additional Myanmar Unicode families from multiple sources.",
    link: "",
    fonts: [
      {
        id: "other:Mon3",
        displayName: "Mon3",
        category: "other",
        filePath: "/other/Mon3.ttf",
        cssFamily: "Mon3",
        previewFamily: "MMFont-Mon3",
        localName: "MON3 Anonta 1",
        downloadFileName: "Mon3.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/Mon3.ttf", downloadFileName: "Mon3.ttf", localName: "MON3 Anonta 1" },
        ],
      },
      {
        id: "other:Myanmar3",
        displayName: "Myanmar3",
        category: "other",
        filePath: "/other/Myanmar3.TTF",
        cssFamily: "Myanmar3",
        previewFamily: "MMFont-Myanmar3",
        localName: "Myanmar3",
        downloadFileName: "Myanmar3.TTF",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/Myanmar3.TTF", downloadFileName: "Myanmar3.TTF", localName: "Myanmar3" },
        ],
      },
      {
        id: "other:MyanmarSansPro",
        displayName: "MyanmarSansPro",
        category: "other",
        filePath: "/other/MyanmarSansPro.ttf",
        cssFamily: "MyanmarSansPro",
        previewFamily: "MMFont-MyanmarSansPro",
        localName: "Myanmar Sans Pro",
        downloadFileName: "MyanmarSansPro.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/MyanmarSansPro.ttf", downloadFileName: "MyanmarSansPro.ttf", localName: "Myanmar Sans Pro" },
        ],
      },
      {
        id: "other:NotoSanMyanmar",
        displayName: "NotoSanMyanmar",
        category: "other",
        filePath: "/other/NotoSanMyanmar.ttf",
        cssFamily: "NotoSanMyanmar",
        previewFamily: "MMFont-NotoSanMyanmar",
        localName: "NotoSansMyanmarRegular",
        downloadFileName: "NotoSanMyanmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/NotoSanMyanmar.ttf", downloadFileName: "NotoSanMyanmar.ttf", localName: "NotoSansMyanmarRegular" },
        ],
      },
      {
        id: "other:NotoSansMyanmarUI",
        displayName: "NotoSansMyanmarUI",
        category: "other",
        filePath: "/other/NotoSansMyanmarUI.ttf",
        cssFamily: "NotoSansMyanmarUI",
        previewFamily: "MMFont-NotoSansMyanmarUI",
        localName: "Noto Sans Myanmar UI",
        downloadFileName: "NotoSansMyanmarUI.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/NotoSansMyanmarUI.ttf", downloadFileName: "NotoSansMyanmarUI.ttf", localName: "Noto Sans Myanmar UI" },
        ],
      },
      {
        id: "other:NotoZawDecode",
        displayName: "NotoZawDecode",
        category: "other",
        filePath: "/other/NotoSansMyanmarUI-Regular-ZawDecode.ttf",
        cssFamily: "NotoZawDecode",
        previewFamily: "MMFont-NotoZawDecode",
        localName: "Noto Sans Myanmar UI",
        downloadFileName: "NotoSansMyanmarUI-Regular-ZawDecode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/NotoSansMyanmarUI-Regular-ZawDecode.ttf", downloadFileName: "NotoSansMyanmarUI-Regular-ZawDecode.ttf", localName: "Noto Sans Myanmar UI" },
        ],
      },
      {
        id: "other:NotoSerifMyanmar",
        displayName: "NotoSerifMyanmar",
        category: "other",
        filePath: "/other/NotoSerifMyanmar.ttf",
        cssFamily: "NotoSerifMyanmar",
        previewFamily: "MMFont-NotoSerifMyanmar",
        localName: "Noto Serif Myanmar",
        downloadFileName: "NotoSerifMyanmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/NotoSerifMyanmar.ttf", downloadFileName: "NotoSerifMyanmar.ttf", localName: "Noto Serif Myanmar" },
        ],
      },
      {
        id: "other:Ours-Unicode",
        displayName: "Ours-Unicode",
        category: "other",
        filePath: "/other/Ours-Unicode.ttf",
        cssFamily: "Ours-Unicode",
        previewFamily: "MMFont-Ours-Unicode",
        localName: "Ours-Unicode",
        downloadFileName: "Ours-Unicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/Ours-Unicode.ttf", downloadFileName: "Ours-Unicode.ttf", localName: "Ours-Unicode" },
        ],
      },
      {
        id: "other:Pyidaungsu",
        displayName: "Pyidaungsu",
        category: "other",
        filePath: "/other/Pyidaungsu.ttf",
        cssFamily: "Pyidaungsu",
        previewFamily: "MMFont-Pyidaungsu",
        localName: "Pyidaungsu",
        downloadFileName: "Pyidaungsu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/Pyidaungsu.ttf", downloadFileName: "Pyidaungsu.ttf", localName: "Pyidaungsu" },
        ],
      },
      {
        id: "other:Yunghkio",
        displayName: "Yunghkio",
        category: "other",
        filePath: "/other/Yunghkio.ttf",
        cssFamily: "Yunghkio",
        previewFamily: "MMFont-Yunghkio",
        localName: "Yunghkio",
        downloadFileName: "Yunghkio.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/Yunghkio.ttf", downloadFileName: "Yunghkio.ttf", localName: "Yunghkio" },
        ],
      },
      {
        id: "other:MyMyanmarUniversal",
        displayName: "MyMyanmarUniversal",
        category: "other",
        filePath: "/other/MyMyanmarUniversal.ttf",
        cssFamily: "MyMyanmarUniversal",
        previewFamily: "MMFont-MyMyanmarUniversal",
        localName: "!MyMyanmar Universal",
        downloadFileName: "MyMyanmarUniversal.ttf",
        languages: ["burmese"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/MyMyanmarUniversal.ttf", downloadFileName: "MyMyanmarUniversal.ttf", localName: "!MyMyanmar Universal" },
        ],
      },
      {
        id: "other:NotoSansMyanmar",
        displayName: "NotoSansMyanmar",
        category: "other",
        filePath: "/other/NotoSansMyanmar-Regular.ttf",
        cssFamily: "NotoSansMyanmar",
        previewFamily: "MMFont-NotoSansMyanmar",
        localName: "NotoSansMyanmar",
        downloadFileName: "NotoSansMyanmar-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/other/NotoSansMyanmar-Regular.ttf", downloadFileName: "NotoSansMyanmar-Regular.ttf", localName: "NotoSansMyanmar" },
        ],
      },
    ],
  },
  {
    key: "sil",
    title: "SIL",
    description: "Padauk and Padauk Book from SIL International, released under the OFL.",
    link: "https://software.sil.org/padauk/",
    fonts: [
      {
        id: "sil:Padauk",
        displayName: "Padauk",
        category: "sil",
        filePath: "/SIL/Padauk-Regular.ttf",
        cssFamily: "Padauk",
        previewFamily: "MMFont-Padauk",
        localName: "Padauk",
        downloadFileName: "Padauk-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SIL/Padauk-Regular.ttf", downloadFileName: "Padauk-Regular.ttf", localName: "Padauk" },
          { weight: 500, italic: false, label: "Medium", filePath: "/SIL/Padauk-Medium.ttf", downloadFileName: "Padauk-Medium.ttf", localName: "Padauk Medium" },
          { weight: 600, italic: false, label: "SemiBold", filePath: "/SIL/Padauk-SemiBold.ttf", downloadFileName: "Padauk-SemiBold.ttf", localName: "Padauk SemiBold" },
          { weight: 700, italic: false, label: "Bold", filePath: "/SIL/Padauk-Bold.ttf", downloadFileName: "Padauk-Bold.ttf", localName: "Padauk Bold" },
          { weight: 800, italic: false, label: "ExtraBold", filePath: "/SIL/Padauk-ExtraBold.ttf", downloadFileName: "Padauk-ExtraBold.ttf", localName: "Padauk ExtraBold" },
        ],
      },
      {
        id: "sil:PadaukBook",
        displayName: "PadaukBook",
        category: "sil",
        filePath: "/SIL/PadaukBook-Regular.ttf",
        cssFamily: "PadaukBook",
        previewFamily: "MMFont-PadaukBook",
        localName: "Padauk Book",
        downloadFileName: "PadaukBook-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
        defaultWeight: 400,
        defaultItalic: false,
        variants: [
          { weight: 400, italic: false, label: "Regular", filePath: "/SIL/PadaukBook-Regular.ttf", downloadFileName: "PadaukBook-Regular.ttf", localName: "Padauk Book" },
          { weight: 500, italic: false, label: "Medium", filePath: "/SIL/PadaukBook-Medium.ttf", downloadFileName: "PadaukBook-Medium.ttf", localName: "Padauk Book Medium" },
          { weight: 600, italic: false, label: "SemiBold", filePath: "/SIL/PadaukBook-SemiBold.ttf", downloadFileName: "PadaukBook-SemiBold.ttf", localName: "Padauk Book SemiBold" },
          { weight: 700, italic: false, label: "Bold", filePath: "/SIL/PadaukBook-Bold.ttf", downloadFileName: "PadaukBook-Bold.ttf", localName: "Padauk Book Bold" },
        ],
      },
    ],
  },
];

export const allFonts: FontDefinition[] = fontCatalog.flatMap((category) => category.fonts);

export const fontStyleCategories: StyleCategory[] = [
  {
    name: "Handwritten / Script",
    fonts: ["MasterpieceLakwel", "MasterpieceUniHand", "MasterpieceYayChanZin", "ThitSarShweSi", "Aka05-Regular", "Aka09-Regular", "SM01_WaTokeLay-Regular", "SM09_BeeZee-Regular"],
  },
  {
    name: "Sans-Serif / Clean UI",
    fonts: ["MyanmarAngoun", "MyanmarChatu", "MyanmarGantgaw", "MyanmarKhyay", "MyanmarKuttar", "MyanmarNayone", "MyanmarNjaun", "MyanmarPauklay", "MyanmarPhetsot", "MyanmarPhikselSmooth", "MyanmarSabae", "MyanmarSagar", "MyanmarSanpya", "MyanmarTagu", "MyanmarThuriya", "MyanmarWaso", "MyanmarYinmar", "MasterpieceStadium", "MasterpieceDaung", "Aka01", "Aka011", "Aka02-Regular", "Aka08-Regular", "Aka10-Light", "OpenDyslexic-Regular", "CherryUnicode", "Kamjing", "MyanmarBlack", "MyanmarHeadOne", "MyanmarSquare", "NKSSmart2", "NKSSmart3", "NKSSmart4", "NamKhoneUnicode", "Yangon", "Mon3", "Myanmar3", "MyanmarSansPro", "NotoSanMyanmar", "NotoSansMyanmarUI", "NotoZawDecode", "Ours-Unicode", "Pyidaungsu", "Yunghkio", "MyMyanmarUniversal", "NotoSansMyanmar", "SM04_Moon", "Padauk", "PadaukBook"],
  },
  {
    name: "Serif / Traditional",
    fonts: ["MasterpieceTawWin", "MasterpieceUniSerif", "YoeYar-One", "NotoSerifMyanmar"],
  },
  {
    name: "Rounded",
    fonts: ["MasterpieceUniRound", "MasterpieceDaungRound"],
  },
  {
    name: "Square / Blocky",
    fonts: ["Aka06-Regular"],
  },
  {
    name: "Typewriter / Monospaced",
    fonts: ["MasterpieceUniType"],
  },
  {
    name: "Display / Decorative",
    fonts: ["MyanmarPhiksel", "MyanmarPonenyet", "MasterpieceCTL", "MasterpieceSpringRev", "OneTypeChiangMai", "OneTypeMMDot", "Aka03-Regular", "SM02_KanBaung-Regular", "SM03_KaWai-Regular", "SM06_LaikPyar-Straight", "SM06_LaikPyar", "SM07_Virus-Regular", "SM08_AntiVirus-Regular"],
  },
];

export const fontLanguageCategories: LanguageCategory[] = [
  {
    id: "burmese",
    name: "Burmese",
  },
  {
    id: "mon",
    name: "Mon",
  },
  {
    id: "shan",
    name: "Shan",
  },
  {
    id: "rakhine",
    name: "Rakhine",
  },
  {
    id: "karen",
    name: "Karen",
  },
  {
    id: "pao",
    name: "Pa'O",
  },
  {
    id: "tailaing",
    name: "Tai Laing",
  },
  {
    id: "khamti",
    name: "Khamti",
  },
];
